export default __webpack_public_path__ + "static/media/truemoney_logo.21566b0b.svg";